import { cx } from "../cx";

/** Four-bar equalizer. Sized by `size` (square box); colour follows `currentColor`. */
export function Spinner({ size = 18, class: cls }: { size?: number; class?: string }) {
  return (
    <span
      class={cx("spinner", cls)}
      role="progressbar"
      aria-label="Loading"
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <i />
      <i />
      <i />
      <i />
    </span>
  );
}
